<template>
    <v-card class="pl-5 pr-5">
      <h1>Customized Journal Collections</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            id="search"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col" v-if="isEdit == false">
          <div class="float-right">
            <v-btn color="primary" @click="onNew" class="mt-4" id="btnNew">
              New Journal Collection
            </v-btn>
          </div>
        </div>
      </div>
      <div v-if="isEdit == true">
        <div class="row">
          <div class="col">
            <v-text-field
              id="CollectionName"
              label="Collection Name*"
              required
              v-model="selectedObj.Name"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              id="Description"
              label="Collection Description"
              v-model="selectedObj.Description"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <!-- <div class="col"> -->
            <!-- <div class="row"> -->
              <!-- <div class="col">
                <v-radio-group v-model="selectAllRecords" column @change="onSelectAll" id="SelectAllDeSelect">
                  <v-radio label="Select All" value="true" id="selectAll"></v-radio>
                  <v-radio label="De Select All" value="false" id="DeSelectAll"></v-radio>
                </v-radio-group>
              </div> -->
              <!-- <div class="col">
                <v-checkbox
                  v-model="selectedObj.isSelectAll"
                  label="Select All"
                  @change="onSelectAll"
                ></v-checkbox>
              </div>
              <div class="col">
                <v-checkbox
                  v-model="selectedObj.isDeSelectAll"
                  label="De Select All"
                  @change="onDeSelectAll"
                ></v-checkbox>
              </div> -->
            <!-- </div> -->
          <!-- </div> -->
           <div class="col">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-width="200"
                id="cardCollection"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="indigo" dark v-bind="attrs" v-on="on" plain id="btnCollection">
                    Selected Items For Collection - ( {{ cartItems.length }} )
                  </v-btn>
                </template>

                <v-card>
                  <v-data-table
                    :headers="journalCartTableHeader"
                    :items="cartItems"
                    hide-default-footer
                    :page.sync="cart_page"
                    :items-per-page="cart_itemsPerPage"
                    @page-count="cart_pageCount = $event"
                    height="500"
                  >
                    <template v-slot:item.Action="{ item }">
                      <div>
                        <v-btn
                          icon
                          color="pink"
                          @click="onSelect({...item, IsSelected: false});"
                          id="btnRemoveCart"
                        >
                          <v-icon>mdi-close-circle-outline</v-icon>
                        </v-btn>
                      </div>
                    </template>
                  </v-data-table>
                  <v-pagination
                    v-model="cart_page"
                    :length="cart_pageCount"
                  ></v-pagination>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="menu = false" id="btnClose">
                      Close
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </div>
          <div class="col"></div>
        </div>
        <div class="row">
          <div class="col">
            <v-card>
              <div class="row">
                <div class="col-5 ml-5">
                  <v-text-field
                    id="search"
                    label="Search"
                    v-model="SearchJournal"
                    append-outer-icon="mdi-table-search"
                    @click:append-outer="onSearchJournals"
                    v-on:keyup.enter="onSearchJournals"
                  ></v-text-field>
                </div>
                <div class="col-6"></div>
              </div>
              <v-divider></v-divider>
              <div style="height: 600px; overflow-y: scroll">
                <v-data-table
                  v-if="showJournal == false"
                  :headers="journalCollectionHeader"
                  :items="journalCollection"
                  item-key="id"
                  hide-default-footer
                  :items-per-page="journalCollection.length"
                  @click:row="showJournal = true;selectedJournalCollectionId = $event.id; getJournals($event.id)"
                >
                </v-data-table>
                <v-data-table
                  v-if="showJournal == true"
                  :headers="publicationHeader"
                  :items="journals"
                  item-key="id"
                  hide-default-footer
                  :items-per-page="journals.length"
                >
                  <template v-slot:item.id="{ item }">
                    <v-simple-checkbox
                      id="Selected"
                      v-model="item.IsSelected"
                      @click="onSelect(item)"
                      :disabled="item.disabled"
                    ></v-simple-checkbox>
                  </template>
                </v-data-table>
                <Pagination :paging="paging_journals_col" v-on:next="onJournalCollectionNextPage" v-if="!showJournal"/>
                <Pagination :paging="paging" v-on:next="onPublicationNextPage" v-if="showJournal"/>
              </div>
            </v-card>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="float-right">
              <v-btn @click="showJournal=false" id="btnBack" v-if="showJournal"> Back </v-btn>
              <v-btn @click="onCancel()" id="btnCancel"> Cancel </v-btn>
              <v-btn
                id="btnSave"
                class="mr-4"
                color="primary"
                @click="onSave()"
                :loading="loading"
                :disabled="loading"
                v-if="!showJournal"
              >
                Save
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <!-- journals Collections -->
      <div class="row" v-if="isEdit == false">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-data-table
            :headers="organizationHeader"
            :items="organizationCollections"
            hide-default-footer
            :items-per-page="organizationCollections.length"
          >
            <template v-slot:item.id="{ item }">
              <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                >mdi-comment-edit</v-icon
              >
              <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                >mdi-delete</v-icon
              >
            </template>
          </v-data-table>
        </div>
      </div>
      <div class="row" v-if="isEdit == false">
        <div class="col">
          <Pagination :paging="paging_orgCollection" v-on:next="onNextPage" />
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </template>
  
  <script>
  import lodash from "lodash";
  import Notification from "@/components/Notification";
  import ConfirmationDialog from "@/components/ConfirmationDialog";
  import Pagination from "@/components/Pagination";
  import PublicationCollections from "@/components/PublicationCollections";
  import * as api from "@/api";
  
  export default {
    components: {
      Pagination,
      Notification,
      ConfirmationDialog
    },
    data() {
      return {
        isEdit: false,
        Search: "",
        SearchJournal: "",
        selectedObj: { journals : []},
        paging_orgCollection: { count: 20, page: 1, size: 20, keyword: "" },
        paging_journals_col: { count: 10, page: 1, size: 10, keyword: "" },
        paging: { count: 20, page: 1, size: 20, keyword: "" },
        journalCollection: [],
        selectedJournalCollectionId: 0,
        showJournal: false,
        organizationHeader: [
          {
            text: "Name",
            align: "start",
            sortable: false,
            value: "Name"
          },
          {
            text: "Description",
            align: "start",
            sortable: false,
            value: "Description"
          },
          {
            text: "",
            align: "start",
            sortable: false,
            value: "id"
          }
        ],
        publicationHeader: [
          {
            text: "",
            align: "start",
            sortable: false,
            value: "id"
          },
          {
            text: "Name",
            align: "start",
            sortable: false,
            value: "Title"
          },
          {
            text: "ISSN",
            align: "start",
            sortable: false,
            value: "ISSN"
          },
          {
            text: "Publisher",
            align: "start",
            sortable: false,
            value: "Publisher"
          }
        ],
        journalCollectionHeader: [
          {
            text: "Name",
            align: "start",
            sortable: false,
            value: "Name"
          },
          {
            text: "Description",
            align: "start",
            sortable: false,
            value: "Description"
          }
        ],
        journals: [],
        organizationCollections: [],
        notify: {
          type: 0,
          message: "",
          errors: []
        },
        overlay: false,
        selectedJournalds: [],
        loading: false,
        selectAllRecords:false,
        disableTable: false,
        disablePage : false,
        cart_page: 1,
        cart_pageCount: 0,
        cart_itemsPerPage: 10,
        cartItems: [],
        menu: false,
        journalCartTableHeader: [
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "Title"
        },
        {
          text: "ISSN",
          align: "start",
          sortable: false,
          value: "ISSN"
        },
        {
          text: "Publisher",
          align: "start",
          sortable: false,
          value: "Publisher"
        },
        {
          text: "Action",
          align: "start",
          sortable: false,
          value: "Action"
        }
      ],
      };
    },
    methods: {
      onSearch() {
        this.paging_orgCollection.page = 1;
        this.paging_orgCollection.keyword = this.Search;
        this.getOrgCollectionByPagin();
      },
      onNextPage(page) {
        console.log("onNextPage " + page);
        this.paging_orgCollection.page = page;
        this.paging_orgCollection.keyword = this.Search;
        console.log(this.paging_orgCollection);
  
        this.getOrgCollectionByPagin();
      },
      onJournalCollectionNextPage(page) {
        console.log("onNextPage pub" + page);
        this.paging_journals_col.page = page;
        this.paging_journals_col.keyword = this.SearchJournal;
        this.getOrgJournalCollectionByPagin();
      },
      onPublicationNextPage(page) {
        console.log("onNextPage pub" + page);
        this.paging.page = page;
        this.paging.keyword = this.SearchJournal;
        this.getJournals(this.selectedJournalCollectionId);
      },
      getOrgJournalCollectionByPagin(){
        new Promise((resolve, reject) => {
          api
            .getByPagin("purchase-order/journal-collection", this.paging_journals_col)
            .then(response => {
              this.journalCollection = response.data.data;
              this.paging_journals_col.count = response.data.count;
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      getOrgCollectionByPagin() {
        let that = this;
        that.overlay = true;
        that.organizationCollections.splice(
          0,
          that.organizationCollections.length
        );
        new Promise((resolve, reject) => {
          api
            .getByPagin("organization-collection/journal", this.paging_orgCollection)
            .then(response => {
              this.paging_orgCollection.count = response.data.count;
              for (let i = 0; i < response.data.data.length; i++) {
                that.organizationCollections.push(response.data.data[i]);
              }
              console.log(that.organizationCollections);
  
              that.overlay = false;
            })
            .catch(error => {
              reject(error);
              that.overlay = false;
            });
        });
      },
      getOrgCollectionDetail(id) {
        let that = this;
        new Promise((resolve, reject) => {
          api
            .getByID("organization-collection/journal", id)
            .then(response => {})
            .catch(error => {
              reject(error);
            });
        });
      },
      getSelectedIds() {
        return api
          .getAll("organization-collection/journal/all/" + this.selectedObj.id)
          .then(response => {
            this.selectedJournalds = [];
            for (let i = 0; i < response.data.data.length; i++) {
                this.selectedJournalds.push({
                  id: response.data.data[i].id
                });
                this.cartItems.push({
                  id: response.data.data[i].id,
                  Title: response.data.data[i].Title,
                  ISSN: response.data.data[i].ISSN,
                  Publisher: response.data.data[i].Publisher
                });
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      getJournals(id) {
        let that = this;
        that.overlay = true;
        this.paging.keyword = this.SearchJournal;
  
        //debugger;
        that.journals.splice(0, that.journals.length);
        new Promise((resolve, reject) => {
          api
            .getByPaginById(
              "organization-collection/collection/journal",
              id,
              this.paging
            )
            .then(response => {
              that.journals = [];
              this.paging.count = response.data.count;

              for (let i = 0; i < response.data.data.length; i++) {
                that.journals.push({
                  id: response.data.data[i].id,
                  Title: response.data.data[i].Title,
                  ISSN: response.data.data[i].ISSN,
                  Publisher: response.data.data[i].Publisher,
                  IsSelected: response.data.data[i].IsSelected
                });
                // if(response.data.data[i].IsSelected)
                //   this.selectedJournalds.push( {id: response.data.data[i].id} );
              }
              this.verifySelectedItems();
              that.overlay = false;
            })
            .catch(error => {
              reject(error);
              that.overlay = false;
            });
        });
      },
      onNew() {
        let that = this;
        this.selectedObj.id = 0;
        this.selectedObj.Name = "";
        this.selectedObj.Description = "";
        this.selectedObj.isCoreCollection = false;
        this.selectedObj.isSelectAll = false;
        this.selectedObj.isDeSelectAll = false;
        this.isEdit = true;
        this.showJournal = false;
        /*
        if (this.journals != null && this.journals.length > 0) {
          that.journals.forEach(e => {
            e.IsSelected = false;
          });
        }
        */
        this.selectedJournalds = [];
        this.paging.count = 1;
        // this.getJournals(0);
      },
      onEdit(item) {
        this.isEdit = true;
        this.selectedObj = Object.assign({}, item);
        this.selectedObj.journals = [];
  
        console.log(this.selectedObj);
        // this.getJournals(item.id);
        this.getSelectedIds();
  
        for (let i = 0; i < this.selectedObj.journals.length; i++) {
         
        }
        console.log(this.selectedJournalds)
        this.showJournal = false;
        
      },
      async onDelete(item) {
        let that = this;
        that.overlay = true;
        if (
          await this.$refs.confirm.open(
            "Confirm",
            "Are you sure, Do you really want to delete this record?"
          )
        ) {
          new Promise((resolve, reject) => {
            api
              .DeleteByID("organization-collection/journal", item.id)
              .then(response => {
                resolve(response);
                if (response.status === 200 || response.status === 201) {
                  this.notify.type = 1;
                  this.notify.message = "Record successfully deleted";
                  this.getOrgCollectionByPagin();
                  this.overlay = false;
                  setTimeout(() => {
                    this.notify.type = 0;
                  }, 3000);
                } else {
                  this.notify.type = 4;
                  this.notify.errors.push("Failed to save data.");
                  this.overlay = false;
                }
              })
              .catch(error => {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data. " + error);
                this.overlay = false;
                reject(error);
              });
          });
        }
        this.overlay = false;
      },
      onCancel() {
        this.isEdit = false;
        this.showJournal = false;
        this.selectedObj = {journals : []};
        this.selectedJournalds = [];
        this.cartItems = [];
        this.menu = false;
        this.paging.keyword = "";
      },
      onSave() {
        console.log(this.selectedObj);
        this.notify.type = 0;
        this.notify.errors = [];
        this.overlay = true;

        this.selectedObj.collectionType = 2;
  
        /*
        var selectedjournals = this.journals.filter(obj => {
          return obj.IsSelected == true;
        });
  
        let selectedJournalds = lodash.map(selectedjournals, function(
          pub
        ) {
          return { id: pub.id };
        });
        */
        console.log("Selected journals to Save");
        this.selectedObj.journals = this.selectedJournalds;
  
        if (this.selectedObj.Name == "") {
          this.notify.type = 4;
          this.notify.errors.push("Please enter Collection name.");
          this.overlay = false;
          return;
        }
  
        if (this.selectedObj.isSelectAll || this.selectedObj.isDeSelectAll) {
          if (this.selectedObj.isSelectAll && this.selectedObj.isDeSelectAll) {
            this.notify.type = 4;
            this.notify.errors.push(
              "Please check 'Select All' or 'De Select All'"
            );
            this.overlay = false;
            return;
          }
        } else {
          if (this.selectedObj.journals.length == 0) {
            this.notify.type = 4;
            this.notify.errors.push("Please select at least one journal.");
            this.overlay = false;
            return;
          }
        }
  
        this.loading = true;
        new Promise((resolve, reject) => {
          api
            .update("organization-collection/journal", this.selectedObj)
            .then(response => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message =
                  this.selectedObj.id === -1
                    ? "Record successfully saved."
                    : "Record successfully updated.";
                this.loading = false;
                this.isEdit = false;
                this.selectAllRecords = false;
                this.getOrgCollectionByPagin();
                this.overlay = false;
                this.showJournal = false;
                this.cartItems = [];
                this.paging.keyword = "";
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
                this.loading = false;
                this.overlay = false;
                this.showJournal = false;
                this.cartItems = [];
                this.paging.keyword = "";
              }
            })
            .catch(error => {
              if (error.message == "Request failed with status code 409") {
                this.notify.type = 4;
                this.notify.errors.push("Collection name already exist");
                this.loading = false;
                this.overlay = false;
                this.showJournal = false;
                this.cartItems = [];
                this.paging.keyword = "";
                reject(error);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data. " + error);
                this.loading = false;
                this.overlay = false;
                this.showJournal = false;
                this.cartItems = [];
                this.paging.keyword = "";
              }
            });
        });
      },
      onSearchJournals() {
        if (this.showJournal == false) {
          this.paging_journals_col.keyword = this.SearchJournal;
          this.paging_journals_col.page = 1;
          this.getOrgJournalCollectionByPagin();
        } else {
          this.paging.keyword = this.SearchJournal;
          this.paging.page = 1;
          this.getJournals(this.selectedJournalCollectionId);
        }
      },
      onSelect(item) {
        var found = this.selectedJournalds.filter(p => p.id == {...item}.id);
        console.log(" found ", found.found );
  
        if (found == undefined || found.length == 0 && {...item}.IsSelected == true) {
          this.selectedJournalds.push({ id: {...item}.id });
          this.cartItems.push({
            id: {...item}.id,
            Title: {...item}.Title,
            ISSN: {...item}.ISSN,
            Publisher: {...item}.Publisher,
          });
        }
        else {
          //for (var i = this.selectedJournalds.length; i--;) {
          for (var i = 0; i < this.selectedJournalds.length; i++) {
            if (this.selectedJournalds[i].id === {...item}.id && {...item}.IsSelected == false ) {
              this.selectedJournalds.splice(i, 1);
              this.cartItems.splice(i, 1);
              this.journals.forEach(e=> {
                if(e.id == {...item}.id) {
                  e.IsSelected = false;
                  e.disabled = false;
                }
              });
              break;
            }
          }
        }
      },
      verifySelectedItems() {
        this.selectedJournalds.forEach(element => {
          var found = this.journals.filter(p => p.id == element.id);
          if (found != undefined && found.length > 0) {
            if (!found[0].IsSelected) found[0].IsSelected = true;
          }
        });
      },
      onSelectAll() {
        if(this.selectAllRecords == "false") {
          this.selectedObj.isSelectAll = false;
          this.selectedObj.isDeSelectAll = true;
          if(this.journals && this.journals.length > 0) {
            this.journals.forEach(e=> {
              e.IsSelected = false;
              e.disabled = false;
            });
          }
        }else {
          this.selectedObj.isSelectAll = true;
          this.selectedObj.isDeSelectAll = false;
          if(this.journals && this.journals.length > 0) {
            this.journals.forEach(e=> {
              e.IsSelected = true;
              e.disabled = true;
            });
          }
        }
      },
    },
    created() {
      this.getOrgCollectionByPagin();
      this.getOrgJournalCollectionByPagin();
    },
    mounted() {}
  };
  </script>
  


// WEBPACK FOOTER //
// src/views/organization/OrgJournalCollection.vue